import PlaceholderImageLoading from './PlaceholderImageLoading';
export default PlaceholderImageLoading;
